async function proxyRequest(callInfo: { url: string, requestBody?: any, headers?: any, isJSON?: boolean}, sid) {
    let response;
    if (callInfo.requestBody) {
        response = await fetch(`/browserapi/proxy?SessionID=${sid}&compat=1`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    method: "POST",
                    url: `${callInfo.url}${callInfo.url.indexOf("?") === -1 ? '?' : '&'}SessionID=${sid}`,
                    body: callInfo.isJSON ? JSON.stringify(callInfo.requestBody) : callInfo.requestBody,
                    headers: callInfo.headers,
                    manageSession: true,
                    mode: "cors",
                    sessionID: sid
                })
            })
    } else {
        response = await fetch(`/browserapi/proxy?SessionID=${sid}&compat=1`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    method: "GET",
                    url: `${callInfo.url}${callInfo.url.indexOf("?") === -1 ? '?' : '&'}SessionID=${sid}`,
                    manageSession: true,
                    mode: "cors",
                    sessionID: sid
                })
            })
    }
    const proxyRes = await response.json();
    if (proxyRes.ok) {
        return proxyRes.result.response;
    }
    return proxyRes.error;
}

export default proxyRequest;